document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function () {
    var heightMenu = document.querySelector('.site-header').offsetHeight;
    var height = window.innerHeight;
    if(document.querySelector('.announcement-bar')) {
      var announcement = document.querySelector('.announcement-bar').offsetHeight;
    } else {
      var announcement = 0;
    }
    document.querySelector('.mobile-navigation').style.height = height - announcement - heightMenu + 'px';
    document.querySelector('.mobile-navigation').style.top = heightMenu + announcement + 'px';
  }, 100);  
});
window.addEventListener('resize', function() {
  setTimeout(function () {
    var heightMenu = document.querySelector('.site-header').offsetHeight;
    var height = window.innerHeight;
    if(document.querySelector('.announcement-bar')) {
      var announcement = document.querySelector('.announcement-bar').offsetHeight;
    } else {
      var announcement = 0;
    }
    document.querySelector('.mobile-navigation').style.height = height - announcement - heightMenu + 'px';
    document.querySelector('.mobile-navigation').style.top = heightMenu + announcement + 'px';
  }, 100);  
}, true);
class ToggleMenu extends HTMLElement {
  constructor() {
    super();
    this.htmlToggle = document.querySelector('html');
    this.addEventListener('click', this.openMenu);
  }
  openMenu() {
    this.htmlToggle.classList.toggle('nav-open');
  }
}
customElements.define('toggle-menu', ToggleMenu);

document.addEventListener("DOMContentLoaded", function() {
  this.querySelectorAll('#mobile_navigation_menu .site-nav .toggle-menu').forEach((button) =>
    button.addEventListener('click', function(e) {
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).next().slideToggle();
    })
  );
  /* Custom Sticky menu */
  if(document.querySelector('#header.sticky-header')){
    var headerHeight = document.querySelector('.sticky-header .site-header').offsetHeight;
    document.querySelector('.sticky-header #pd-sticky').style.height = headerHeight + 'px';
    window.addEventListener('resize', function() {
      setTimeout(function () {
        var headerHeight = document.querySelector('.sticky-header .site-header').offsetHeight;
        document.querySelector('.sticky-header #pd-sticky').style.height = headerHeight + 'px';
      }, 200);  
    }, true);
  }
  if(document.querySelector('#header.sticky-header-mobile')){
    var headerHeight = document.querySelector('.sticky-header-mobile .site-header').offsetHeight;
    document.querySelector('.sticky-header-mobile #pd-sticky-mobile').style.height = headerHeight + 'px';
    window.addEventListener('resize', function() {
      setTimeout(function () {
        var headerHeight = document.querySelector('.sticky-header-mobile .site-header').offsetHeight;
        document.querySelector('.sticky-header-mobile #pd-sticky-mobile').style.height = headerHeight + 'px';
      }, 200);  
    }, true);
  }
  /* Custom Sticky header only when scroll down not scroll up */
  if (document.querySelector('#header.sticky-header') || document.querySelector('#header.sticky-header-mobile')) {
    var lastScrollTop = 0;
    var navbarHeight = document.querySelector('#header').offsetHeight;
    // on scroll, let the interval function know the user has scrolled
    window.addEventListener('scroll', function() {
      if (!$('.header-cart').hasClass('active') && !$('html').hasClass('nav-open') && !$('html').hasClass('nav-open-additional-menu')) {
        var st = $(this).scrollTop();

        // If they scrolled down and are past the navbar, add class .nav-up.
        // This is necessary so you never see what is "behind" the navbar.
        if (st > lastScrollTop && st > navbarHeight){
            // Scroll Down
            $('#header').removeClass('nav-down').addClass('nav-up');
            var headerHeightMobile = $('.sticky-header-mobile .site-header').height();
            $('.nav-up .site-header .header-cart .cart-slideout,.nav-up .site-header .header-cart.toggle-cart-slide:after').css('top',headerHeightMobile+'px');
        } else {
            // Scroll Up
            if (st > navbarHeight) {
              if(st + $(window).height() < $(document).height()) {
                $('#header').removeClass('nav-up').addClass('nav-down');
                  $('.site-header .header-cart .cart-slideout,.site-header .header-cart.toggle-cart-slide:after').css('top',0+'px');
              }
            }
            if (st == 0) {
              $('#header').removeClass('nav-up').removeClass('nav-down');
                $('.site-header .header-cart .cart-slideout,.site-header .header-cart.toggle-cart-slide:after').css('top',0+'px');
            }
        }
        
        lastScrollTop = st;
      }
    }, true);
  }
});


// // Find the element with the href attribute containing "/collections/clearance-sale"


// var spanElement = document.querySelector('li.normal-menu.level0.w-1-column.menu-8 a.level0 span');
// if (spanElement) {
//   spanElement.style.color = 'red';
// }


// dhaval edit start

var spanElements = document.querySelectorAll('li.normal-menu.level0.w-1-column.menu-8 a.level0 span');
if (spanElements) {
  for (var i = 0; i < spanElements.length; i++) {
    spanElements[i].style.color = 'red';
  }
}

// dhaval edit end